import Modal from '../modules/modal.js';
import { Nav, SubNav } from '../modules/nav.js';
import Widget from '../modules/widget';
import Dropdown from '../modules/dropdown';
import SlidingSidebar from '../modules/sliding-sidebar.js';

export default {
  init() {
    const PhoneModal = new Modal('.js-phone-modal', '.js-phone-modal-button');
    PhoneModal.toggleEvent();

    const NavPrimary = new Nav('.js-nav-mobile', '.js-nav-button');
    NavPrimary.toggleNav();

    const NavCategories = new Nav('.js-categories-container', '.js-categories-button');
    NavCategories.toggleNav();

    const subNav = new SubNav('.menu-item-has-children');
    subNav.toggleSubNav();

    const slidingSidebar = new SlidingSidebar('.sliding_sidebar', '.sliding_sidebar-toggler', '.sliding_sidebar-content');
    slidingSidebar.init();

    // CATEGORY WIDGET ON MOBILE

    const categoryWidget = new Widget('.widget_product_categories', '.js-open-category-widget', 'widget-opened');
    categoryWidget.toggleWidget();

    // CATEGORY WIDGET - SUBCATEGORIES DROPDOWN

    const categoryChildrenDropdown = new Dropdown('.cat-parent', 'subcategory-opened');
    categoryChildrenDropdown.initStateOpen();
    categoryChildrenDropdown.toggleDropdown();
  },

  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js